import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BuildIcon from "@mui/icons-material/Build";
import axios from "axios";
import API_BASE_URL from '../../src/config';
import { UserContext } from "../context/UserContext"; // Import your UserContext

const ServiceDetails = () => {
  const { id } = useParams();
  const { user } = useContext(UserContext); // Access the user from context
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // State to store any errors
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // Fetch the service details from the API
    const fetchServiceDetails = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/services/${id}`);
        // const response = await axios.get(`http://localhost:5000/api/services/${id}`);

        setService(response.data); // Set the fetched service details
      } catch (err) {
        console.error("Error fetching service details:", err);
        setError("Failed to load service details. Please try again later.");
      } finally {
        setLoading(false); // Stop loading after fetching
      }
    };

    fetchServiceDetails();
  }, [id]); // Fetch details whenever the ID changes

  const handleShowInterest = async () => {
  if (!service || !user || submitting) return;

  setSubmitting(true); // disable button while submitting

  const payload = {
    user_id: user.id,
    opportunity_provider_id: service.user_id,
    opportunity_id: service.id,
    user_name: user.name,
    opportunity_name: service.service_name,
  };

  try {
    const res = await axios.post(`${API_BASE_URL}/services/show-interest`, payload);
    const msg = res.data?.message || "Your interest has been sent!";
    alert(msg);
  } catch (err) {
    console.error("Error sending interest:", err);
    alert("Failed to send interest. Please try again later.");
  } finally {
    setSubmitting(false);
  }
};
 

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ textAlign: "center", mt: 5 }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ textAlign: "center", mt: 5,mb:4 }}>
        <Typography color="error">{error}</Typography>
      </Container>
    );
  }

  if (!service) {
    return (
      <Container maxWidth="md" sx={{ textAlign: "center", mt: 5 }}>
        <Typography>No service details found.</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 5,mb:4 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" color="primary" fontWeight="bold" textAlign="center">
            {service.service_name}
          </Typography>

          <Box display="flex" alignItems="center" mt={2}>
            <PersonIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body1">
              <strong>{service.your_name}</strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center" mt={1}>
            <LocationOnIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body1">{service.location}</Typography>
          </Box>

          <Box display="flex" alignItems="center" mt={1}>
            <BuildIcon color="action" sx={{ mr: 1 }} />
            <Typography variant="body1">{service.description}</Typography>
          </Box>

          <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{ mt: 3 }}
          onClick={handleShowInterest}
          disabled={submitting}
            >
          {submitting ? "Sending..." : "Show Interest"}
          </Button>

        </CardContent>
      </Card>
    </Container>
  );
};

export default ServiceDetails;
